import { EVENTS_SEARCH } from '../../constants/actions';
import { searchQuerySelector } from '../../selectors/events/search';
import { allStagesSelector } from '../../selectors/events/timetable';

export const openSearch = () => ({ type: EVENTS_SEARCH.OPEN });
export const closeSearch = () => ({ type: EVENTS_SEARCH.CLOSE });
export const clearSearch = () => ({ type: EVENTS_SEARCH.CLEAR });

export const searchInput = query => ({
    type: EVENTS_SEARCH.INPUT,
    query
});

export const search = () => {
    return async (dispatch, getState) => {
        const query = searchQuerySelector(getState());
        if (query.length > 0) {
            dispatch({ type: EVENTS_SEARCH.FETCH_START });
            const filteredResults = [];
            const stages = allStagesSelector(getState());
            stages.forEach(stage => {
                stage.Performances.forEach(p => {
                    if (p.Artist && (p.Artist.name || '').toLowerCase().includes(query.toLowerCase())) {
                        filteredResults.push({ ...p, stageName: stage.name, stageDate: stage.date });
                    }
                });
            });
            dispatch({
                type: EVENTS_SEARCH.FETCH_OK,
                results: filteredResults
            });
        } else {
            dispatch({
                type: EVENTS_SEARCH.FETCH_OK,
                results: []
            });
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/events/search.js